import { PATH_WIDTH } from 'constants/map';
import styled, { css } from 'styled-components';

const tourActiveStyles = css`
    @keyframes pathanimate {
        0% {
            stroke-width: ${PATH_WIDTH + 2.5};
        }

        50% {
            stroke-width: ${PATH_WIDTH + 4.5};
        }

        100% {
            stroke-width: ${PATH_WIDTH + 2.5};
        }
    }

    .selected-path {
        animation: pathanimate 2s linear infinite;
    }
`;

export const PathGroup = styled.g<{ isPathSelectedInTour: boolean }>`
    pointer-events: stroke;
    cursor: pointer;
    ${({ isPathSelectedInTour }) => isPathSelectedInTour && tourActiveStyles};
`;
